import { render, staticRenderFns } from "./ExportLinksTab.vue?vue&type=template&id=5c737f51&scoped=true"
import script from "./ExportLinksTab.vue?vue&type=script&lang=js"
export * from "./ExportLinksTab.vue?vue&type=script&lang=js"
import style0 from "./ExportLinksTab.vue?vue&type=style&index=0&id=5c737f51&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c737f51",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c737f51')) {
      api.createRecord('5c737f51', component.options)
    } else {
      api.reload('5c737f51', component.options)
    }
    module.hot.accept("./ExportLinksTab.vue?vue&type=template&id=5c737f51&scoped=true", function () {
      api.rerender('5c737f51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/Export/ExportLinksTab.vue"
export default component.exports